import type { ReactNode } from 'react';
import { RevealGroup, moDelay } from '@/lib/motion/Reveal';

interface SectionHeaderProps {
  index: string;
  name: string;
  title: ReactNode;
  titleId: string;
  meta?: ReactNode;
  /** 'inverse' is only for text placed over photography. */
  tone?: 'default' | 'inverse';
  as?: 'h1' | 'h2';
  className?: string;
}

export const microCls = 'font-label text-[11px] font-medium uppercase leading-none tracking-[0.12em]';

/**
 * Global section header with ONE shared reveal:
 * micro row (6px / 360ms) → title (16px / 500ms, +60ms) → meta (fade / 400ms, +120ms).
 */
export default function SectionHeader({
  index, name, title, titleId, meta, tone = 'default', as = 'h2', className = '',
}: SectionHeaderProps) {
  const micro = tone === 'inverse' ? 'text-white/80' : 'text-foreground-500';
  const titleColor = tone === 'inverse' ? 'text-white' : 'text-foreground-950';
  const Title = as;
  const strong = tone === 'inverse'; // text over Studio photography: strongest entrance
  return (
    <RevealGroup as="header" className={`mb-10 md:mb-12 ${className}`}>
      <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-2">
        <p className={`mo-item ${strong ? 'mo--micro-strong' : 'mo--micro'} ${microCls} ${micro} whitespace-nowrap`}>{index} — {name}</p>
        {meta && <p className={`mo-item mo--fade ${microCls} ${micro}`} style={moDelay(120)}>{meta}</p>}
      </div>
      <Title id={titleId} className={`mo-item ${strong ? 'mo--title-strong' : 'mo--title'} mt-6 max-w-4xl font-heading text-[32px] font-medium leading-[1.05] tracking-[-0.02em] md:text-[42px] ${titleColor}`} style={moDelay(60)}>
        {title}
      </Title>
    </RevealGroup>
  );
}